import React from 'react'
import Icons from '@/components/icons/IconMap'
import './Toolbar.css'

interface ToolbarProps {
  searchPlaceholder?: string
  onSearch?: (term: string) => void
  children?: React.ReactNode
  actions?: React.ReactNode
}

export const Toolbar: React.FC<ToolbarProps> = ({
  searchPlaceholder = 'Buscar...',
  onSearch,
  children,
  actions,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('')

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    onSearch?.(value)
  }

  return (
    <div className="toolbar">
      <div className="toolbar__search">
        <Icons.Search size="sm" className="toolbar__searchIcon" />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          className="toolbar__searchInput"
        />
      </div>

      {children && <div className="toolbar__filters">{children}</div>}

      {actions && <div className="toolbar__actions">{actions}</div>}
    </div>
  )
}
